<template>
  <nav class="main-nav">
    <button
      class="butn main-nav__close js-main-nav__close"
      aria-label="close"
      @click="closeNav"
      v-html="ExitIcon"
    ></button>

    <MainNavList :navLinks="navLinks" />

    <MainNavSocialsLinks class="show--md" :links="socialLinks" />
  </nav>
</template>

<script>
import MainNavList from "./MainNavList.vue";
import MainNavSocialsLinks from "./MainNavSocialsLinks";
import ExitIcon from "../../assets/icons/exit.svg";

export default {
  name: "main-nav",
  props: {
    navLinks: Array,
    socialLinks: Array,
    user: {}
  },
  components: {
    MainNavList,
    MainNavSocialsLinks
  },
  data() {
    return {
      ExitIcon
    };
  },
  methods: {
    closeNav() {
      this.$emit("closeNav");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.butn {
  @include butn;
}

.show--md {
  @media (min-width: $screen-md-min) {
    display: none !important;
  }
}

.main-nav {
  transition: transform $transitionSlide;

  @media (max-width: $screen-sm-max) {
    position: absolute;
    top: 0;
    left: auto;
    right: -315px;
    height: 100vh;
    padding: 70px 30px 30px;
    z-index: 0;
    max-width: 315px;
    width: 100%;
    background-color: #1f1f1f;
    text-align: left;
    overflow-y: scroll;
  }
}

.main-nav__close {
  display: none;
  position: absolute;
  top: 16px;
  right: 50px;
  font-size: 20px;
  color: #fff;

  @media (max-width: $screen-sm-max) {
    display: block;
  }
}

.main-nav__account {
  margin: 35px 0;
}
</style>

<style>
.main-nav__close svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
</style>
